/**
 * @generated SignedSource<<391fa37bd82e7c8c0612c5be399d9087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type relatedWorkProgressBar_versionProgress$data = ReadonlyArray<{
  readonly node: {
    readonly __typename: "JiraVersionRelatedWorkConfluenceReleaseNotes";
    readonly url: AGG$URL | null | undefined;
  } | {
    readonly __typename: "JiraVersionRelatedWorkGenericLink";
    readonly url: AGG$URL | null | undefined;
  } | {
    readonly __typename: "JiraVersionRelatedWorkNativeReleaseNotes";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "relatedWorkProgressBar_versionProgress";
} | null | undefined>;
export type relatedWorkProgressBar_versionProgress$key = ReadonlyArray<{
  readonly " $data"?: relatedWorkProgressBar_versionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"relatedWorkProgressBar_versionProgress">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "name": "url"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "relatedWorkProgressBar_versionProgress",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "JiraVersionRelatedWorkGenericLink"
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/)
            ],
            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
          }
        ]
      },
      "action": "NONE",
      "path": "node"
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};
})();

(node as any).hash = "c40509aabe2c6731ba0d792fff68b169";

export default node;
